import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import Sections from "./Sections";
import ReactSignatureCanvas from "react-signature-canvas";
import { isDocumentExpired } from "../../utils/miscHelper";
import styles from "./DynamicSections.module.scss";
import { isObject } from "lodash";
const DynamicSections = (props) => {
  const { documentSections, sectionWithSigned, document, redirectToList } = props;

  const [trimmedDataURL, setTrimmedDataURL] = useState("");
  const [sectionId, setSectionId] = useState();
  const [showSignModal, setShowSignModal] = useState(false);
  const [isSigningDocument, setIsSigningDocument] = useState(false);
  const [alert, setAlert] = useState(props.alert);
  const [updating, setUpdating] = useState(false);
  const { t } = useTranslation();
  const sigpad = useRef(null);
  useEffect(() => {
    setAlert(props.alert);
  }, [props.alert]);

  const hideAlert = () => {
    setAlert(false);
  };

  const clear = () => {
    sigpad.current.clear();
    setTrimmedDataURL("");
  };

  const addTouchScreenSignature = (sectionIdInput) => {
    setSectionId(sectionIdInput);
    setShowSignModal(true);
    setTrimmedDataURL("");
  };

  const onModalClose = () => {
    setShowSignModal(false);
    setSectionId(null);
    setUpdating(false);
  };

  const addTouchSignatureDoc = () => {
    setUpdating(true);
    let sectionTobeSigned = documentSections.filter((e) => e.isSectionSignatureRequired === true);
    let sectionsSigned = documentSections.filter((e) => e.sectionSignedHtml !== null);
    if (sectionsSigned.length === sectionTobeSigned.length) {
      setTrimmedDataURL("");
      setShowSignModal(true);
    } else {
      setAlert(true);
    }
  };

  const completeSectionSignature = (sectionIdInput) => {
    setUpdating(true);
    setIsSigningDocument(true);
    props
      .completeSectionSignature(
        sectionIdInput && !isObject(sectionIdInput) ? sectionIdInput : sectionId,
        trimmedDataURL
      )
      .then((result) => {
        setIsSigningDocument(false);
        setSectionId(null);
        setTrimmedDataURL("");
        onModalClose();
      });
  };

  const updateStates = () => {
    setUpdating(true);
    props.updateStates(null, trimmedDataURL).then((result) => {
      if (result) {
        setUpdating(false);
        if (result.alert) {
          onModalClose();
          setAlert(true);
        } else {
          onModalClose();
          redirectToList();
        }
      } else {
        onModalClose();
      }
    });
  };

  const isExpired = isDocumentExpired(new Date(), document.document.expiryDate);

  return (
    <div className="dashboard-list-item">
      {alert && (
        <SweetAlert
          warning
          showCancel
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="default"
          onConfirm={hideAlert}
          onCancel={hideAlert}>
          {t("AgreementDocuments.SectionSignature.ErrorMessage")}
        </SweetAlert>
      )}

      <div className="row">
        <div className="col-xs-12 col-sm-8 col-md-9" style={{ paddingTop: "1px", fontSize: "22px", color: "brown" }}>
          {document.document.name}
        </div>
        <div className="col-xs-12 col-sm-4 col-md-3">
          <Button
            variant="outline-secondary"
            onClick={redirectToList}
            style={{ width: "165px", border: "1px solid #DDD", padding: "10px" }}
            disabled={updating}>
            {t("Action.Back")}
          </Button>
        </div>
      </div>
      {/* <Loading className="loading-component" isLoading={this.state.isLoading || this.props.loading} /> */}
      <div
        className={`row ${styles.customScrollbar}`}
        style={{ height: "600px", overflowY: "scroll", marginTop: "40px" }}>
        {documentSections &&
          documentSections.length > 0 &&
          documentSections.map((section) => {
            return (
              <div key={section.sectionId}>
                <Sections
                  section={section}
                  sectionWithSigned={sectionWithSigned}
                  isSigningDocument={isSigningDocument}
                  addTouchScreenSignature={() => addTouchScreenSignature(section.sectionId)}
                  completeSectionSignature={() => completeSectionSignature(section.sectionId)}
                />
              </div>
            );
          })}
      </div>
      {document.document.isDocumentSingReqested && document.document.status !== 3 && (
        <div
          className="row col-xs-12 col-sm-12 col-md-12"
          style={{ width: "103%", height: "80px", marginTop: "15px", backgroundColor: "#EFEFEF" }}>
          <div
            className="col-xs-12 col-md-6 col-md-6"
            style={{ padding: "21px 0px 10px 59px", fontSize: "22px", fontWeight: "500" }}>
            <span>{t("AgreementDocuments.agreementDocumentAcceptMessagee")}</span>
          </div>
          <div className="col-xs-8 col-md-6 col-lg-6">
            {isExpired && (
              <div className={styles.agreeSign}>
                <Button disabled style={{ width: "165px", border: "1px solid #DDD" }}>
                  {t("Action.AgreeSign")}
                </Button>
                <OverlayTrigger
                  placement="right"
                  trigger={["click", "hover", "focus"]}
                  overlay={
                    <Tooltip id="adddocument.conditions.exclude">
                      {t("AgreementDocuments.expiredDocumentsMessage")}
                    </Tooltip>
                  }>
                  <span style={{ display: "inline", padding: "7px" }}>
                    <i className="glyphicon glyphicon-info-sign" />
                  </span>
                </OverlayTrigger>
              </div>
            )}

            {document.document.isDocumentSingReqested && !isExpired && (
              <div className={`row ${styles.p10}`}>
                {document.document.isTouchSignatureUI ? (
                  <Button
                    disabled={isSigningDocument}
                    className={styles.touchSignbtn}
                    style={{ display: "block", float: "right", marginTop: "13px" }}
                    variant="success"
                    size="sm"
                    onClick={() => addTouchSignatureDoc()}>
                    {`Click here to Sign`}
                  </Button>
                ) : (
                  <Button
                    disabled={updating}
                    onClick={() => updateStates(document.id)}
                    style={{ width: "165px", border: "1px solid #DDD" }}>
                    {t("Action.AgreeSign")}
                  </Button>
                )}
              </div>
            )}
          </div>
        </div>
      )}

      <Modal show={showSignModal} onHide={onModalClose} backdrop="static">
        <Modal.Header closeButton className="brand-primary">
          <Modal.Title>{"Draw your signature here"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <ReactSignatureCanvas
              penColor="black"
              backgroundColor="white"
              canvasProps={{ height: 100, width: 500 }}
              ref={sigpad}
              onEnd={() => {
                const imageData = sigpad.current.getTrimmedCanvas().toDataURL("image/png");
                setTrimmedDataURL(imageData);
              }}
            />

            <div className="row">
              <div className="col-md-12">
                <Button className="btn btn-danger" onClick={clear}>
                  Clear
                </Button>
                <Button
                  className="btn btn-success pull-right"
                  disabled={trimmedDataURL === ""}
                  onClick={sectionId != null ? completeSectionSignature : updateStates}>
                  Done
                </Button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
};

DynamicSections.propTypes = {
  documentSections: PropTypes.array.isRequired,
  sectionWithSigned: PropTypes.array.isRequired,
  document: PropTypes.object.isRequired,
  redirectToList: PropTypes.func.isRequired,
  completeSectionSignature: PropTypes.func.isRequired,
  updateStates: PropTypes.func.isRequired,
};
export default DynamicSections;
